import "./privilege.css";
import React from "react";
import WhatsappFloatComponent from "components/comun/whatsapp";
import { useLocation } from "react-router-dom";

import PorqueElegirnos from "./porque-elegirnos";
import Servicios from "./servicios";
import Contacto from "./contacto";
import PreguntasFrecuentes from "./preguntas-frecuentes";

const Privilege = ({ children }) => {

  const [index, setIndex] = React.useState(0);
  // const [sidemenu, setSidemenu] = React.useState([]);

  const location = useLocation();

  

  // const parser = new DOMParser();



  // React.useEffect(() => {
  //   window.scrollTo({ top: 0 });

  //   //const sidemenu = [...children.template2.sidemenu];
  //   mySort(sidemenu, "order");

    
  //   setSidemenu(sidemenu);
  // }, [children]);

  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const sectionBackgroundImage = {
    background: `url("${children?.template2?.fondo?.url}")`,
    // backgroundSize: 'cover',
    backgroundColor: "#dedbd9",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    backgroundPosition: "center",
    height: "100%",
    backgroundAttachment: "fixed",
  };
  

  return (
    <section style={sectionBackgroundImage}>
      {location.pathname==="/pages/recaudacion-de-fondos-1" && (
        <WhatsappFloatComponent href={"https://wa.me/5491171239251"} />
      )}
      <div className="container-lg pb-5">
        <div className="row pt-5">
          <div className="col-md-3 col-lg-3">
            <div className="d-flex flex-column justify-content-center">
             
                <h2 className="internacion__titulo mb-4">Privilege HB</h2>
             
              <div className="d-flex flex-column mb-4">
               
                    <button
                      type="button"
                
                      className="btn grandiend-btn my-1"
                      onClick={() => setIndex(0)}
                    >
                      ¿Por qué elegirnos?
                    </button>

                      <button
                      type="button"
                
                      className="btn grandiend-btn my-1"
                      onClick={() => setIndex(1)}
                    >
                      Servicios
                    </button>

                      <button
                      type="button"
                
                      className="btn grandiend-btn my-1"
                      onClick={() => setIndex(2)}
                    >
                      Contacto
                    </button>

                      <button
                      type="button"
                
                      className="btn grandiend-btn my-1"
                      onClick={() => setIndex(3)}
                    >
                      Preguntas frecuentes
                    </button>
                
              </div>
            </div>
          </div>
          <div className="col-md-9 col-lg-9">            
              {index===0 && <PorqueElegirnos/>}
              {index===1 && <Servicios/>}
              {index===2 && <Contacto/>}
              {index===3 && <PreguntasFrecuentes/>}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Privilege;
